import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick"];
import { useCallback } from 'react';
import { StyledSeeMoreLink } from "./see-more-link.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SeeMoreLink = function SeeMoreLink(_ref) {
  var onClick = _ref.onClick,
    seeMoreLink = _objectWithoutProperties(_ref, _excluded);
  var handleClick = useCallback(function (event) {
    onClick === null || onClick === void 0 ? void 0 : onClick({
      item: seeMoreLink,
      event: event
    });
  }, [onClick, seeMoreLink]);
  return /*#__PURE__*/_jsxs(StyledSeeMoreLink, {
    href: seeMoreLink.href,
    target: seeMoreLink.target,
    onClick: handleClick,
    children: [seeMoreLink.label, /*#__PURE__*/_jsx("svg", {
      fill: "none",
      height: "9",
      viewBox: "0 0 10 9",
      width: "10",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/_jsx("path", {
        d: "M8.12482 5.01677L5.04164 8.26826L5.73528 9L10 4.5L5.73528 0L5.04164 0.731741L8.12482 3.98323H0V5.01677H8.12482Z",
        fill: "currentColor"
      })
    })]
  });
};
export default SeeMoreLink;